import { useTranslation } from "react-i18next";

export function FormikErrorMessage(props: any) {
    const { t } = useTranslation();
    return <div className="text-danger">{t(props.children)}</div>;
}
